import React, { useEffect, useLayoutEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { buttonLabels } from "../shared/constants";
import SettingsHeader from "./settingsHeader.component";
import ButtonComponent from "../shared/button/button.component";
import { AppRoutes } from "../routes/route.path";
import { BusinessHoursModel, DaysInAWeek } from "../../models/channels/channels.model";
import SelectBusinessHoursComponent from "./select-business-hours.component";
import { FormControlLabel, Checkbox, Grid, Autocomplete, TextField } from "@mui/material";
import * as selector from "../../selectors/selectors"
import { useNavigate } from "react-router-dom";
import { ChannelService } from "../../services/channels/ChannelAcountService";
import { ChannelUserService } from "../../services/ChannelUserService";
import ArrowTimePickerComponent from "../shared/datetimepicker/arrow-timepicker.component";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";


interface Props {
}

const BusinessHoursComponent: React.FC<Props> = (props: Props) => {

    const time = (time) => {
        let currentDate = new Date();

        currentDate.setHours(time, 0, 0, 0);

        let milliseconds = currentDate.getTime();

        return milliseconds
    }

    const InitialBusinessHours: BusinessHoursModel[] = [{
        DAY: DaysInAWeek.MONDAY,
        OPEN_TIME: time(9),
        CLOSE_TIME: time(18),
        SELECTED: false,
    }, {
        DAY: DaysInAWeek.TUESDAY,
        OPEN_TIME: time(9),
        CLOSE_TIME: time(18),
        SELECTED: false,
    }, {
        DAY: DaysInAWeek.WEDNESDAY,
        OPEN_TIME: time(9),
        CLOSE_TIME: time(18),
        SELECTED: false,
    }, {
        DAY: DaysInAWeek.THURSDAY,
        OPEN_TIME: time(9),
        CLOSE_TIME: time(18),
        SELECTED: false,
    }, {
        DAY: DaysInAWeek.FRIDAY,
        OPEN_TIME: time(9),
        CLOSE_TIME: time(18),
        SELECTED: false,
    }, {
        DAY: DaysInAWeek.SATURDAY,
        OPEN_TIME: time(9),
        CLOSE_TIME: time(18),
        SELECTED: false,
    }, {
        DAY: DaysInAWeek.SUNDAY,
        OPEN_TIME: time(9),
        CLOSE_TIME: time(18),
        SELECTED: false,
    }]

    const navigate = useNavigate();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const CurrentUser = ChannelUserService.getCurrentUserFromLocalStorage();

    const [BusinessHours, setBusinessHours] = useState<BusinessHoursModel[]>(InitialBusinessHours);
    const [alwaysOpen, setAlwaysOpen] = useState<boolean>(false);
    const [PermananentlyClosed, setPermanentlyClosed] = useState<boolean>(false);
    const [isloading, setIsLoading] = useState<boolean>(false);
    const [businessHoursType, setBusinessHoursType] = useState<string>("Custom")

    const [commonStartTime, setCommonStartTime] = useState<number>(time(9))
    const [commonEndTime, setCommonEndTime] = useState<number>(time(18))




    // const [flag, setFlag] = useState<boolean>(false)

    // const handleBusinessHours = (data: BusinessHoursModel) => {
    //     let newBusinessHours = BusinessHours
    //     if (newBusinessHours.find(x => x.DAY === data.DAY).OPEN_TIME !== data.OPEN_TIME) {
    //         newBusinessHours.find(x => x.DAY === data.DAY).OPEN_TIME = data.OPEN_TIME
    //     }
    //     if (newBusinessHours.find(x => x.DAY === data.DAY).CLOSE_TIME !== data.CLOSE_TIME) {
    //         newBusinessHours.find(x => x.DAY === data.DAY).CLOSE_TIME = data.CLOSE_TIME
    //     }
    //     if (newBusinessHours.find(x => x.DAY === data.DAY).SELECTED !== data.SELECTED) {
    //         newBusinessHours.find(x => x.DAY === data.DAY).SELECTED = data.SELECTED
    //     }
    //     setBusinessHours(newBusinessHours)
    // console.log(BusinessHours)
    // setFlag(!flag)
    // }

    // useEffect(() => {
    //     console.log("HAHHA", BusinessHours)
    // }, [BusinessHours])

    const handleBusinessHours = (data) => {
        const newBusinessHours = BusinessHours.map(x => x.DAY === data.DAY ? data : x)
        if (newBusinessHours.find(x => x.SELECTED === true)) {
            setPermanentlyClosed(false)
            setAlwaysOpen(false)
        }
        setBusinessHours(newBusinessHours)
    }

    const handleAlwaysOpen = () => {
        const newBusinessHours = BusinessHours.map((x: BusinessHoursModel) => x && { ...x, OPEN_TIME: time(0), CLOSE_TIME: time(0), SELECTED: !alwaysOpen })
        setAlwaysOpen(!alwaysOpen)
        setPermanentlyClosed(false)
        setBusinessHours(newBusinessHours)
    }

    const handlePermanentlyClosed = () => {
        setPermanentlyClosed(!PermananentlyClosed)
        setAlwaysOpen(false)
        setBusinessHours(InitialBusinessHours)
    }

    const createBusinessHours = () => {
        setIsLoading(true)
        let obj = {
            "business_hours": alwaysOpen ? [] : BusinessHours.filter(x => x.SELECTED).map(x => ({ day_of_week: x.DAY, open_time: businessHoursType === "Custom" ? x.OPEN_TIME : commonStartTime, close_time: businessHoursType === "Custom" ? x.CLOSE_TIME : commonEndTime })),
            "always_open": alwaysOpen,
            "permanently_closed": PermananentlyClosed
        }
        ChannelService.CreateBusinessHours(CurrentUser.OrganizationID, 4, obj).then((res) => {
            navigate(AppRoutes.SETTINGS)
            setIsLoading(false)
            setToast("Business Hours has been updated sucessfuly", ToasterType.SUCCESS)
        }).catch((err) => {
            setIsLoading(false)

        })
    }

    useLayoutEffect(() => {
        ChannelService.GetBusinessHours(CurrentUser.OrganizationID, 4).then((res) => {
            setPermanentlyClosed(res.data.permanently_closed)

            if (res.data.always_open) {
                setAlwaysOpen(res.data.always_open)
                setBusinessHours(BusinessHours.map((x: BusinessHoursModel) => x && { ...x, OPEN_TIME: time(0), CLOSE_TIME: time(0), SELECTED: true }))
            }
            else {
                let hours = BusinessHours.map(x => {
                    const updatedDay = res.data.custom_business_hours.find(y => y.day_of_week.toLowerCase() === x.DAY.toLowerCase());
                    if (updatedDay) {
                        return {
                            ...x,
                            OPEN_TIME: Date.parse(updatedDay.open_time),
                            CLOSE_TIME: Date.parse(updatedDay.close_time),
                            SELECTED: true
                        }
                    } else {
                        return x
                    }
                })
                setBusinessHours(hours)
            }
        }).catch((err) => {

        })
    }, [])

    const handleBusinessHoursType = (value) => {
        setBusinessHoursType(value)
        if (value === "Daily") {
            setBusinessHours(InitialBusinessHours.map(x => { return { ...x, OPEN_TIME: commonStartTime, CLOSE_TIME: commonEndTime, SELECTED: true } }))
            setAlwaysOpen(false)
            setPermanentlyClosed(false)
        }
        if (value === "Weekdays") {
            setBusinessHours(InitialBusinessHours.map(x => { return (x.DAY != ("Sunday") && x.DAY != ("Saturday")) ? { ...x, OPEN_TIME: commonStartTime, CLOSE_TIME: commonEndTime, SELECTED: true } : { ...x, SELECTED: false } }))
            setAlwaysOpen(false)
            setPermanentlyClosed(false)
        }
        if (value === "Weekend") {
            setBusinessHours(InitialBusinessHours.map(x => { return (x.DAY === ("Sunday") || x.DAY === ("Saturday")) ? { ...x, OPEN_TIME: commonStartTime, CLOSE_TIME: commonEndTime, SELECTED: true } : { ...x, SELECTED: false } }))
            setAlwaysOpen(false)
            setPermanentlyClosed(false)
        }
        if (value === "Custom") {
            setBusinessHours(InitialBusinessHours)
        }
    }

    const handleOpenTime = (time) => {
        setCommonStartTime(time)
    }

    const handleCloseTime = (time) => {
        setCommonEndTime(time)
    }




    return (
        <div className={`${IsMobileDevice ? "" : ""} w-p-100`}>
            <div className="w-p-100 d-flex align-center mb-2">
                <Autocomplete
                    disableClearable
                    classes={{ input: 'h5-medium color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                    value={businessHoursType}
                    size="small"
                    className={` ${IsMobileDevice ? "w-p-30" : "w-15"} h-p-100 mr-4`}
                    options={["Custom", "Daily", "Weekdays", "Weekend"]}
                    onChange={(e, value) => { handleBusinessHoursType(value) }}
                    renderInput={
                        (params) =>
                            <TextField
                                {...params}
                                name="BusinessHours Type"
                                variant="outlined"
                                label="Type"
                                inputProps={{ ...params.inputProps, readOnly: true }}
                            />
                    }
                />
                {businessHoursType !== 'Custom' &&
                    <>
                        <div className={` ${IsMobileDevice ? "w-p-30" : "w-15"} h-p-100`}>
                            <ArrowTimePickerComponent Value={commonStartTime} handleChange={handleOpenTime} TextLabel={""} IsMobileDevice={IsMobileDevice} ClassName={"br-1"} IsDisabled={false} />
                        </div>
                        <div className="w-p-4 h-p-100 d-flex justify-center align-center">
                            -
                        </div>
                        <div className={` ${IsMobileDevice ? "w-p-30" : "w-15"} h-p-100`}>
                            <ArrowTimePickerComponent Value={commonEndTime} handleChange={handleCloseTime} TextLabel={""} IsMobileDevice={IsMobileDevice} ClassName={"br-1"} IsDisabled={false} />
                        </div>
                    </>
                }
            </div>
            {businessHoursType === "Custom" &&
                <div className={`${IsMobileDevice ? "h-p-100" : "h-p-60"}`}>
                    {
                        BusinessHours.map((x: BusinessHoursModel) => (<SelectBusinessHoursComponent BusinessHours={x} IsMobileDevice={IsMobileDevice} handleBusinessHours={handleBusinessHours} DisableSelect={alwaysOpen || PermananentlyClosed} />))
                    }
                    <div className="w-p-100 h-p-12 d-flex align-center mt-1 ">
                        <div className="w-26 o-hidden">
                            <FormControlLabel classes={{ label: `${IsMobileDevice ? "h5-medium" : "h5-medium"} w-space color-primary-accent ` }} control={
                                <Checkbox
                                    className=""
                                    checked={alwaysOpen}
                                    value={alwaysOpen}
                                    onChange={handleAlwaysOpen}
                                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                />}
                                label={"Always Open"}
                            />
                        </div>
                        {/* <div className="w-p-58 o-hidden">
                            <FormControlLabel classes={{ label: `${IsMobileDevice ? "h5-medium" : "h5-medium"} w-space color-primary-accent ` }} control={
                                <Checkbox
                                    className=""
                                    checked={PermananentlyClosed}
                                    value={PermananentlyClosed}
                                    onChange={handlePermanentlyClosed}
                                    classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                />}
                                label={"Permananently Closed"}
                            />
                        </div> */}
                    </div>
                </div>
            }
            {businessHoursType != "Custom" &&
                <div className="d-flex ">
                    {
                        BusinessHours.map(x => {
                            return (
                                <div className={`w-4 h-4 br-p-50 ${x.SELECTED ? "bg-color-primary-light" : "bg-color-settings-nav-bar-option"} color-secondary d-flex align-center justify-center h5-medium mr-1`}>
                                    {x.DAY.slice(0, 2)}
                                </div>
                            )
                        })
                    }
                </div>
            }
            <div className={`w-p-100 d-flex mt-2 justify-flex-end ${IsMobileDevice ? "mx-2" : ""}`}>
                <ButtonComponent
                    OnClick={() => { createBusinessHours() }}
                    ButtonLabel={buttonLabels.SAVE}
                    Loading={isloading}
                    Variant={BusinessHours?.find(x => x.SELECTED === true) || alwaysOpen || PermananentlyClosed ? "primary-btn-small" : "disabled-btn-small"}
                    ClassName={`c-pointer w-space mr-1`}
                />
            </div>
        </div>
    )
}

export default BusinessHoursComponent;